export default __webpack_public_path__ + "3ed1650414929ab2b9c1ad37385d1d06.jpg";